import { useState } from "react";
import { motion } from "framer-motion";
import MagneticButton from "@/components/ui/MagneticButton";

export default function MoodTuner() {
  const [energy, setEnergy] = useState(50);
  const [mood, setMood] = useState(50);

  // Dynamic recommendations based on sliders
  const getRec = () => {
    if (energy < 30 && mood < 40) return { label: "Deep Rest", color: "from-blue-500 to-purple-500" };
    if (energy > 70 && mood < 40) return { label: "Burnout Triage", color: "from-orange-500 to-red-500" };
    if (energy > 70 && mood > 70) return { label: "Focus Sprint", color: "from-emerald-400 to-teal-500" };
    return { label: "Daily Balance", color: "from-nilyTeal to-neurovaPurple" };
  };

  const rec = getRec();

  return (
    <div className="w-full max-w-md mx-auto p-6 rounded-3xl bg-[var(--glass-bg)] border border-[var(--glass-border)] backdrop-blur-xl shadow-2xl relative overflow-hidden">
      
      {/* Background Reactive Mesh */}
      <motion.div 
        className={`absolute inset-0 bg-gradient-to-br ${rec.color} opacity-20 blur-[80px] transition-colors duration-1000`}
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 4, repeat: Infinity }}
      />

      <div className="relative z-10 space-y-8">
        <div className="text-center space-y-1">
          <h3 className="font-heading text-xl text-[var(--text-main)]">How are you right now?</h3>
          <p className="text-xs text-[var(--text-muted)] font-mono uppercase tracking-widest">Interactive Sync</p>
        </div>

        {/* Sliders */}
        <div className="space-y-6">
          <div className="space-y-3">
            <div className="flex justify-between text-xs text-[var(--text-muted)] font-medium">
              <span>Low Energy</span>
              <span>High Energy</span>
            </div>
            <input 
              type="range" 
              min="0" max="100" 
              value={energy} 
              onChange={(e) => setEnergy(e.target.value)}
              className="w-full h-2 rounded-full appearance-none bg-white/20 cursor-pointer accent-[var(--nily-teal)]"
            />
          </div>

          <div className="space-y-3">
            <div className="flex justify-between text-xs text-[var(--text-muted)] font-medium">
              <span>Unsettled</span>
              <span>Calm</span>
            </div>
            <input 
              type="range" 
              min="0" max="100" 
              value={mood} 
              onChange={(e) => setMood(e.target.value)}
              className="w-full h-2 rounded-full appearance-none bg-white/20 cursor-pointer accent-[var(--neurova-purple)]"
            />
          </div>
        </div>

        {/* Result Card */}
        <div className="p-4 rounded-xl bg-white/10 border border-white/10 flex items-center justify-between">
          <div>
            <div className="text-[10px] text-[var(--text-muted)] uppercase">Suggested Ritual</div>
            <div className="font-heading text-lg text-[var(--text-main)]">{rec.label}</div>
          </div>
          <MagneticButton className="px-4 py-2 text-xs h-auto">Start</MagneticButton>
        </div>
      </div>
    </div>
  );
}
